import { UserDiscoData, UserDiscoContext } from '@disco/ui';
import { callApi } from '@disco/utils';
import { useCallback, useContext } from 'react';

export const useApi = () => {
  const { token } = useContext<UserDiscoData>(UserDiscoContext);
  const callApiCallback = useCallback((url, options) => callApi(url, { token, ...options }), [token]);
  return callApiCallback;
};
